import { useTheme } from "@/theme/ThemeProvider";

export function ThemeToggle() {
  const { mode, toggleMode } = useTheme();
  const nextMode = mode === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      onClick={toggleMode}
      aria-label={`Switch to ${nextMode} mode`}
      className="flex h-11 w-11 items-center justify-center rounded-full border border-outline/20 bg-surface-high text-lg text-text transition hover:border-primary/40 hover:text-primary"
    >
      <span aria-hidden="true">{mode === "dark" ? "☼" : "☾"}</span>
    </button>
  );
}
